import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2fba590a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "fixed-nav",
  class: "fixed-nav"
}
const _hoisted_2 = {
  class: "w-full",
  role: "navigation"
}
const _hoisted_3 = { class: "navigation" }
const _hoisted_4 = { class: "navigation__list" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "mobile-nav" }
const _hoisted_7 = { class: "navigation__list" }
const _hoisted_8 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("h1", null, [
          _createVNode(_component_router_link, {
            to: _ctx.ROUTES.HOME.path,
            class: "logo",
            "data-test": "logo"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Job Oaikhenah: Software Engineer ")
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.name,
                "data-test": "nav-item-mobile",
                class: _normalizeClass(['navigation__item', _ctx.active === item.url ? 'active' : ''])
              }, [
                (item.type === 'external')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: item.url,
                      class: "navigation__link"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: item.url,
                      class: "navigation__link",
                      onClick: _withModifiers(($event: any) => (_ctx.handleNavigation(item)), ["prevent"])
                    }, _toDisplayString(item.name), 9, _hoisted_5))
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "floating-logo",
        "aria-labelledby": "Floating logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileNav && _ctx.toggleMobileNav(...args)))
      }),
      _createElementVNode("nav", {
        "aria-labelledby": "mobile navigation",
        class: _normalizeClass({ navigation: true, isOpen: _ctx.isOpen }),
        role: "navigation"
      }, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name,
              "data-test": "nav-item-mobile",
              class: _normalizeClass(['navigation__item', _ctx.active === item.url ? 'active' : ''])
            }, [
              (item.type === 'external')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: item.url,
                    class: "navigation__link",
                    onClick: ($event: any) => (_ctx.handleNavigation(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: item.url,
                    class: "navigation__link",
                    onClick: _withModifiers(($event: any) => (_ctx.handleNavigation(item)), ["prevent"])
                  }, _toDisplayString(item.name), 9, _hoisted_8))
            ], 2))
          }), 128))
        ])
      ], 2)
    ])
  ]))
}